export class MonthlyPayments {
  constructor() {
    this.principleInterest = 493;
    this.pmi = 0;
    this.homeownersInsuranceAmount = 29.17;
    this.floodInsuranceAmount = 0;
    this.taxesAmount = 58.33;
    this.hoaDuesAmount = 0;
    this.totalMonthlyPayment = 580;
  }
}
